import React from "react";
import MotionIconButton from "../icons/MotionIcon";

export default function ClauseTemplateHeader({ onAdd }) {
  return (
    <div className="text-black pb-3 h-[60px] flex items-center justify-between">
      <h1 className="font-semibold text-[15px] dark:text-white">Clauses</h1>
      <MotionIconButton tooltip="Add Clauses" onClick={onAdd} />
    </div>
  );
}
